import {doStyleProductFlags, doStyleProductsListing} from "../blocks/productsListing";
import {HelperFunctions} from "../config/helperFunctions";
import {doStyleSidebarFilters} from "../blocks/sidebar-filters";
import {HtmlBlocks} from "../config/htmlBlocks";
import {TranslationsManager} from "../utils/localisationManager";

export class ProductPage {
    static EventListeners = {
        'ShoptetVariantAvailable': ProductPage.doReplaceMainProdImageOnChange,
        'ShoptetDOMAdvancedOrderLoaded': ProductPage.doShoptetDOMAdvancedOrderLoaded,
    }
    static doShoptetDOMAdvancedOrderLoaded() {
        ProductPage.doStyleAdvancedOrder();
    }

    static async doInit() {
        ProductPage.doStyleMisc()
        doStyleSidebarFilters();
        ProductPage.doChangeMainImgWithChevron()

        HelperFunctions.doStyleBreadcrumbOnProduct();
        doStyleProductsListing();
        doStyleProductFlags();

        ProductPage.doFixImageSizes();
        ProductPage.doReplaceMainProdImageOnChange();
        ProductPage.doStyleAlterntiveAndSimilarProducts();
        ProductPage.doStyleSizeChart();
        return true;
    }

    static doReplaceMainProdImageOnChange() {
        const prodImgHtmlElem = $('.p-detail .p-image img');
        HelperFunctions.doReplaceProductMainImageSrc(prodImgHtmlElem[0]);
    }
    static doStyleMisc() {
        if($(window).width() >= 768) {
            $('.p-detail-inner-header').prependTo('.p-info-wrapper');
        }
        $('.product-top > div:nth-child(1)').insertAfter('.p-detail-inner-header');
        $('.p-detail .add-to-cart > button').text(`${TranslationsManager.doGetStringByLang('IN_BASKET_BTN')}`);
        $('.p-detail .description-inner .basic-description a:contains("Fotobook kolekce")').addClass('fotobook-link'); //TODO: update :contains

        if($('.p-info-wrapper .detail-parameters td').length === 0) {
            $('.p-info-wrapper .detail-parameters').addClass('hidden');
            $('.p-info-wrapper .availability-value').addClass('no-variant');
        }

        const $variantSelect = $('.p-detail .detail-parameters select');
        if($variantSelect.length === 1) {
            ProductPage.doStyleSingleVariants();
            $variantSelect.closest('table').addClass('single-variant');
        }
    }

    static doFixImageSizes() {
        HelperFunctions.doReplaceImageSourceAttributes( '.p-detail .p-image img', "/big/", "/orig/");
    }

    static doChangeMainImgWithChevron() {
        if($('.p-thumbnail').length > 0) {
            $('.p-detail .p-image').append(`<div class="change-img"><a href="#" class="img-prev"></a><a href="#" class="img-next"></a></div>`);
        }

        let thumbnails = $('a.p-thumbnail');
        let currentImgIndex = 0;
        $('.change-img > a').on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            let direction = $(event.target).hasClass('img-next') ? 'increment' : 'decrement';
            if(direction === 'increment') {
                if(currentImgIndex === (thumbnails.length - 1)) {
                    currentImgIndex = 0;
                } else {
                    currentImgIndex += 1;
                }
            } else {
                if(currentImgIndex === 0) {
                    currentImgIndex = thumbnails.length - 1;
                } else {
                    currentImgIndex -= 1;
                }
            }

            $('.p-main-image img').attr('src', $(thumbnails[currentImgIndex]).attr('href'));
            // HelperFunctions.setProductMainImageToOrig();
            $(thumbnails).removeClass('highlighted');
            $(thumbnails[currentImgIndex]).addClass('highlighted');
        })
    }
    static doStyleAlterntiveAndSimilarProducts() {
        $('.shp-tab-link[href="#productsAlternative"]').parent().remove();

        const $altSimProd = $(HtmlBlocks.SHP_TABS_RELATED_SIMILAR());
        $altSimProd.insertAfter('.p-detail-tabs-wrapper');
        $('#tab-content #productsAlternative').children().appendTo($($altSimProd).find('#alternativeProducts'));
        $('.products-related.products-additional').appendTo($($altSimProd).find('#similarProducts'));

        HelperFunctions.waitForElement('.tab-content #similarProducts').then(() => {
            $('.btn-default:contains("Zobrazit všechny související produkty")').closest('.browse-p').appendTo('.tab-content #similarProducts'); //TODO: update :contains
        })

        HelperFunctions.waitForElement('.tab-content #similarProducts').then(() => {
            HelperFunctions.waitForElement('.tab-content #alternativeProducts').then(() => {
                const $alterProducts = $('#alternativeProducts .product');
                const $similarProducts = $('#similarProducts .product');

                if($alterProducts.length === 0) {
                    $('.shp-tabs-wrapper.custom-shp #p-detail-tabs > li:first-child').removeClass('active').addClass('hidden');
                    $('.shp-tabs-wrapper.custom-shp #p-detail-tabs > li:last-child').removeClass('hidden').addClass('active');

                    $('.tab-content #alternativeProducts').removeClass('in active');
                    $('.tab-content #similarProducts').addClass('in active');
                }
                if($similarProducts.length === 0) {
                    $('.shp-tabs-wrapper.custom-shp #p-detail-tabs > li:first-child').removeClass('hidden').addClass('active');
                    $('.shp-tabs-wrapper.custom-shp #p-detail-tabs > li:last-child').removeClass('active').addClass('hidden');

                    $('.tab-content #similarProducts').removeClass('in active');
                    $('.tab-content #alternativeProducts').addClass('in active');
                }
                if(($alterProducts.length === 0) && ($similarProducts.length === 0)) {
                    $('.shp-tabs-wrapper.custom-shp').addClass('hidden');
                }
            })
        })
    }

    static doStyleSizeChart() {
        let shouldAppendWrapper = false;
        const $chart = $('.basic-description img');
        $(`<div class="modal-chart hidden">
                        <div class="modal-content"></div>
                    </div>`).appendTo('.overall-wrapper');
        $chart.each(function (index, element) {
            const $chartAlt = $(element).attr('alt');

            if($chartAlt && $chartAlt.includes('Tabulka')) {
                shouldAppendWrapper = true;
                $('.modal-chart').removeClass('hidden');
                $(`<div class="img"></div>`).appendTo('.modal-chart .modal-content');

                $(element).appendTo(`.modal-chart .modal-content .img:nth-child(${index+1})`);
                $(HtmlBlocks.BG_OVERLAY()).prependTo('.modal-chart');
                $(HtmlBlocks.CLOSE_BTN_OVERLAY()).prependTo('.modal-chart .modal-content .img');
            }
        })

        if(shouldAppendWrapper) {
            HelperFunctions.doAppendSizeChartWrapper();
        }

        $('.modal-chart-trigger').click(function () {
            $('body').toggleClass('modal-chart-visible');
        })
    }

    static doStyleAdvancedOrder() {
        $(`
            <div class="extra back">
                <button type="button" class="close-btn">${TranslationsManager.doGetStringByLang('CONTINUE_SHOPPING')}</button>
            </div>
        `).insertBefore('.advanced-order .extras-wrap .extra.step');

        $('.extra.back button').click(function () {
            shoptet.modal.close()
        })
    }

    static doStyleSingleVariants() {
        if ($("#product-detail-form .variant-list").length == 0) {
            return;
        }
        var $select = $('#product-detail-form .variant-list select');

        var options = parseInt($select.find( 'option' ).length);

        $select.closest('td').attr('colspan', 2);//.prev('th').remove();

        $select.wrap('<div id="select-variants"></div>');
        var $wrapperSelect = $('#select-variants');
        var $div = $('<div />');

        var parameterId = parseInt($select.attr('data-parameter-id'));

        $div.attr('data-parameter-id', parameterId);
        $wrapperSelect.append($div);

        var select_name = $select.attr('id');
        $select.find('option').each(function(i){

            var isDefault = (i == 0 && $(this).val() == '' ? true : false);

            var $label = (isDefault ? $('<span />') : $('<label />'));
            var $span = $('<span />');
            var $input = $('<input type="radio" name="'+ select_name +'"'+ (isDefault || options == 1 ? ' checked="checked"' : '') +' />');

            $span.html($(this).text());

            for (let j = 0; j < $(this)[0].attributes.length; j++)
            {
                var a = $(this)[0].attributes[j];
                $input.attr(a.name, a.value);
            }

            $label.append($input);
            if (!isDefault) {
                $label.append($span);
            }

            var paramValue = $(this).val() == '' ? 'default-variant' : parameterId +'-'+ $(this).val();
            if ($('.p-basic-info-block .parameter-dependent.'+ paramValue +' .availability-label').length > 0) {
                var $availability = $('.p-basic-info-block .parameter-dependent.'+ paramValue +' .availability-label');
                if ($.trim($availability.text()) == 'Vyprodáno') { // TODO: update 'Vyprodáno'
                    $input.attr('disabled', true);
                }
            }

            $div.append($label);


            $input.click(function(){
                //$select.find('option').attr('selected', false);
                //$wrapperSelect.find('input:radio').attr('checked', false);
                $(this).attr('checked', 'checked');
                $select.val($(this).val()).change();
            });
        });

        $select.hide();
        $('#select-variants input[selected="selected"]').attr('checked', 'checked');
    }
}

